<template>
    <div class="wrapper-content w-100">
      <h1>{{title}}</h1>
      <LmBreadcrumb />
      <LmForm ref="lmFormRef">
        <div class="row">
          <div class="col-12 col-lg-2">
            <LmTextInput
              v-model="form.n_legajo"
              :v="$v.form.n_legajo"
              label="N legajo"
              type="number"
              :disabled="true"
              />
          </div>
          <div class="col-12 col-lg-5">
            <LmTextInput
              v-model="form.nombre"
              label="Nombre"
              :disabled="true"
              />
          </div>
          <div class="col-12 col-lg-5">
            <LmTextInput
              v-model="form.apellido"
              label="Apellido"
              :disabled="true"
              />
          </div>
          <div class="col-12 col-lg-6">
            <LmSuperPowerSelect
              :data="lmSuperPowerSelects.oficinas.selectOptions"
              :tbColumns="lmSuperPowerSelects.oficinas.tbColumns"
              label="Oficina"
              placeholder="Oficina"
              :model="sanitizeModel(form.c_oficina)"
              :pageSize="20"
              :v="$v.form.c_oficina"
              @values="updateOficina($event)"
            />
          </div>
          <div class="col-12 col-lg-6">
            <LmTextInput
              v-model="form.secretaria"
              label="Secretaria"
              :disabled="true"
              />
          </div>
          <div class="col-12">
            <LmTextInput
              v-model="form.d_email"
              label="Email"
              :disabled="true"
              />
          </div>
          <LmSuperPowerSelect
            class="col-12"
            :data="lmSuperPowerSelects.roles.selectOptions"
            :tbColumns="lmSuperPowerSelects.roles.tbColumns"
            label="Roles"
            placeholder="Roles"
            :multiple="true"
            :model="sanitizeModel(form.rolId)"
            @values="updateRol($event)"
          />
          <div class="col-12 col-lg-6">
            <LmButton
              type="button"
              buttonClass="btn-secondary"
              :isProcessing="isFormProcessing"
              :value="$t('Cancel')"
              @click.native="cancelBtn"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
            />
            <LmButton
              type="submit"
              buttonClass="btn-primary"
              :isProcessing="isFormProcessing"
              :value="$t('Save')"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              @click.native="submit"
              />
          </div>
        </div>
      </LmForm>
    </div>
</template>

<script>
import commonsApi from '@/api/commons'
import { mapActions } from 'vuex'

import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmToasts from '@/mixins/lmToasts.js'
import { required, numeric } from 'vuelidate/lib/validators'

import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts],
  components: {
    LmForm,
    LmTextInput,
    LmButton,
    LmSuperPowerSelect
  },
  data () {
    return {
      lmSuperPowerSelects: {
        oficinas: {
          selectOptions: [],
          tbColumns: [
            { title: 'Oficina', data: 'name' }
          ]
        },
        roles: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'name' },
            { title: 'Descripción', data: 'd_rol' }
          ]
        }
      },
      form: {
        n_legajo: '',
        apellido: '',
        nombre: '',
        secretaria: '',
        d_email: '',
        oficina: '',
        c_oficina: null,
        rolId: [],
        rolName: []
      },
      isFormProcessing: false
    }
  },
  validations: {
    form: {
      c_oficina: {
        required,
        numeric
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    updateRol (values) {
      this.form.rolId = values.map(e => e.id)
      this.form.rolName = values.map(e => e.name.trim())
    },
    async updateOficina (values) {
      if (values.length) {
        this.form.oficina = values[0].name
        this.form.c_oficina = values[0].id
        const detalleOficina = await commonsApi.getItemDetail({
          path: 'oficinas/detail',
          id: this.form.c_oficina,
          paramsMode: true
        })
        this.form.secretaria = detalleOficina.d_secretaria ? detalleOficina.d_secretaria : ''
      } else {
        this.form.oficina = ''
        this.form.c_oficina = null
        this.form.secretaria = ''
      }
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    async submit () {
      try {
        this.isFormProcessing = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        const dataToSendToTheServer = {
          c_rol: this.form.rolName,
          c_oficina: this.form.c_oficina,
          n_legajo: this.$route.params.id
        }
        let apiUrl = `${process.env.VUE_APP_API_URL}roles_x_usuario/`
        let response = await this.updateItemDetail({
          path: apiUrl,
          data: dataToSendToTheServer
        })

        if (response.id) {
          this.lmToastSuccessInternalLink(`/usuarios/edit/${response.id}`, 'Ver Detalle', `Roles Modificados para Legajo: ${response.id}`)
        }
        this.$router.push(this.onSuccessDestinationRoute)
      } catch (error) {
        console.log(error)
      } finally {
        this.isFormProcessing = false
      }
    }
  },
  mounted () {
    (async () => {
      this.$refs.lmFormRef.showLoading()
      try {
        const response = await this.getAllLmSuperPowerSelectOptions(
          [
            {
              name: 'roles',
              obj: {
                path: 'roles/',
                total: null
              }
            },
            { name: 'oficinas',
              obj: {
                path: 'oficinas/predictivo/',
                total: 1000
              }
            }
          ])

        for (const e of response) {
          this.lmSuperPowerSelects[e.name].selectOptions = e.data
        }

        const responseUsuarioDetail = await commonsApi.getItemDetail({
          path: 'usuarios',
          id: this.$route.params.id,
          paramsMode: true
        })
        const responseRolesPorUsuario = await commonsApi.getItemDetail({
          path: 'roles_x_usuario',
          id: this.$route.params.id,
          paramsMode: true
        })
        const mapRolesNameToRolesId = responseRolesPorUsuario.map(element => {
          return this.lmSuperPowerSelects.roles.selectOptions.find(el => {
            if (element.rol.trim() === el.name.trim()) {
              return el.id
            }
          })
        })
        const idArray = mapRolesNameToRolesId.map(e => e.id)
        this.form = responseUsuarioDetail
        this.form.rolId = idArray
        // Si no existen roles para el usuario se inicializa a un array vacio
        // rolName
        if (responseRolesPorUsuario.length === 0) {
          this.form.rolName = []
        }
      } finally {
        this.isFormProcessing = false
        this.$refs.lmFormRef.hideLoading()
      }
    })()
  }
}
</script>
